import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, ExternalLink } from 'lucide-react';

// Canonical AtlasGeo product surfaces — keep in sync with project_atlasgeo_product_map.
const PRODUCTS = [
  { label: 'AtlasGeo home',        url: 'https://atlasgeo.ai',                 tag: 'Main site' },
  { label: 'Atlas Corridor (maps)', url: 'https://maps.atlasgeo.ai',           tag: 'Maps' },
  { label: 'Atlas Studio',         url: 'https://studio.atlasgeo.ai',          tag: 'Data → maps SaaS' },
  { label: 'AtlasSafe Explorer',   url: 'https://api.atlasgeo.ai/explore',     tag: 'Crash insights' },
  { label: 'AtlasLive DMV',        url: 'https://live.atlasgeo.ai',            tag: 'Traffic & incidents' },
  { label: 'QMD Generator',        url: 'https://qmd.atlasgeo.ai',             tag: 'Map-prep demo' },
  { label: 'AtlasCare Access Map', url: 'https://recursos.atlasgeo.ai',        tag: 'PW County resources' },
];

export default function NetworkMenu({ variant = 'dark' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const triggerCls = variant === 'dark'
    ? 'text-stone-600 hover:text-[#0a0a0a] hover:bg-stone-100 border-stone-200'
    : 'text-stone-200 hover:text-white hover:bg-white/10 border-white/20';

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className={`px-3 py-1.5 text-xs uppercase tracking-wider transition-colors border ${triggerCls} inline-flex items-center gap-1.5`}
      >
        AtlasGeo network
        <ChevronDown size={12} className={open ? 'rotate-180 transition-transform' : 'transition-transform'} />
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-72 bg-white border border-stone-200 shadow-soft z-20">
          <div className="px-3 py-2 border-b border-stone-100 text-[10px] uppercase tracking-widest text-stone-500">
            AtlasGeo product network
          </div>
          {PRODUCTS.map((p) => (
            <a
              key={p.url}
              href={p.url}
              target="_blank"
              rel="noreferrer noopener"
              className="flex items-start justify-between gap-2 px-3 py-2 hover:bg-stone-50 border-b border-stone-50 last:border-0"
              onClick={() => setOpen(false)}
            >
              <div className="flex-1 min-w-0">
                <div className="text-sm text-[#0a0a0a] font-medium">{p.label}</div>
                <div className="text-[11px] text-stone-500 truncate">{p.tag}  ·  {p.url.replace(/^https?:\/\//, '')}</div>
              </div>
              <ExternalLink size={12} className="text-stone-400 mt-1 flex-shrink-0" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
